var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('div', {
    class: _vm.classObj,
    style: ({
      width: _vm.width,
      height: _vm.height
    }),
    on: {
      "click": _vm.focus
    }
  }, [_vm._l((_vm.currentValue), function(item, index) {
    return [(index == _vm.currentPosition) ? [_c('n3-typeahead', {
      ref: "typeahead",
      refInFor: true,
      style: ({
        margin: '0px 5px'
      }),
      attrs: {
        "placeholder": _vm.placeholder,
        "async": _vm.async,
        "width": _vm.inputWidth,
        "items": _vm.citems,
        "dropdown-width": _vm.dropdownWidth,
        "dropdown-height": _vm.dropdownHeight,
        "on-hit": _vm.add,
        "match-case": _vm.matchCase,
        "limit": _vm.limit,
        "itemRender": _vm.itemRender,
        "data": _vm.data
      },
      on: {
        "focus": _vm._onFocus,
        "blur": _vm._onBlur,
        "change": _vm._onInputchange
      },
      nativeOn: {
        "keydown": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
          _vm.del($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
          if ('button' in $event && $event.button !== 0) { return null; }
          _vm.left($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "right", 39)) { return null; }
          if ('button' in $event && $event.button !== 2) { return null; }
          _vm.right($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.add($event)
        }]
      },
      model: {
        value: (_vm.currentQuery),
        callback: function($$v) {
          _vm.currentQuery = $$v
        },
        expression: "currentQuery"
      }
    })] : [_c('span', {
      class: (_vm.prefixCls + "-multiple-input-space"),
      on: {
        "click": function($event) {
          _vm.setIndex(index)
        }
      }
    })], _vm._v(" "), _c('span', {
      class: (_vm.prefixCls + "-multiple-input-m-tag")
    }, [_c('render', {
      staticClass: "inline",
      attrs: {
        "context": _vm.context || _vm.$parent._self,
        "template": _vm.format(item, index)
      }
    }), _vm._v(" "), _c('n3-icon', {
      class: (_vm.prefixCls + "-multiple-close"),
      attrs: {
        "type": "times"
      },
      nativeOn: {
        "click": function($event) {
          _vm.clickDel(index)
        }
      }
    })], 1)]
  }), _vm._v(" "), (_vm.currentValue && _vm.currentValue.length == _vm.currentPosition) ? [_c('n3-typeahead', {
    ref: "typeahead",
    style: ({
      margin: '0px 5px'
    }),
    attrs: {
      "placeholder": _vm.placeholder,
      "async": _vm.async,
      "width": _vm.inputWidth,
      "items": _vm.citems,
      "dropdown-width": _vm.dropdownWidth,
      "dropdown-height": _vm.dropdownHeight,
      "on-hit": _vm.add,
      "match-case": _vm.matchCase,
      "limit": _vm.limit,
      "itemRender": _vm.itemRender,
      "data": _vm.data
    },
    on: {
      "focus": _vm._onFocus,
      "blur": _vm._onBlur,
      "change": _vm._onInputchange
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.del($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        _vm.left($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39)) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        _vm.right($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.add($event)
      }]
    },
    model: {
      value: (_vm.currentQuery),
      callback: function($$v) {
        _vm.currentQuery = $$v
      },
      expression: "currentQuery"
    }
  })] : [_c('span', {
    class: (_vm.prefixCls + "-multiple-input-space " + _vm.prefixCls + "-multiple-input-long"),
    on: {
      "click": function($event) {
        _vm.setIndex(_vm.currentValue.length)
      }
    }
  })]], 2), _vm._v(" "), _c('validate', {
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules,
      "custom-validate": _vm.customValidate,
      "current": _vm.value
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-473275e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-473275e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/MultipleInput/n3MultipleInput.vue
// module id = 621
// module chunks = 0 1